import React from 'react';
import * as YAA from '../actions/yourAccountActions';
import { VIEWS } from '../../utils/yourAccountUtils';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { Request } = ssCommonUtils;

const init = {
    view: VIEWS.YOUR_ACCOUNT,
    showView: false,
    roles: [],
    role: '',
    firstName: null,
    lastName: null,
    contactInfo: [],
    requests: {
        data: new Request,
        updateContactInfo: new Request,
        updateSecurityQuestions: new Request,
        updatePassword: new Request,
        emailPreferences: new Request,
        emailPreferencesUpdate: new Request
    },
    emailAddress: '',
    phoneNumber: '',
    securityQuestion1: '',
    securityQuestion2: '',
    securityQuestion3: '',
    oldPassword: '',
    newPassword1: '',
    newPassword2: '',
    emailPreferences: []
}

export default function yourAccountReducers(state = init, action) {
    const
    getData = target => {
        const data = payload.contactInformation;

        for(let i in data)
            if(data[i].contactType === target)
                return data[i].contactValue;

        return null;
    },
    setStateValues = (d, s) => {
        if(d != null) d.map(e => {
            if(s.hasOwnProperty(e.field))
                s[e.field] = e.value;
        });

        return s;
    };

    let payload = null;

    if(action.hasOwnProperty('payload'))
        payload = action.payload;

    switch(action.type) {
        case YAA.YOUR_ACCOUNT_REQUEST:
            return {...state, requests: {...state.requests,
                data: {...state.requests.data, status: 'pending' }
            }};

        case YAA.SUCCESS_YOUR_ACCOUNT_REQUEST:
            return {...state,
                requests: {...state.requests, data: {...state.requests.data, status: 'success' }},
                id: payload.id,
                firstName: payload.personalInformation.firstName,
                lastName: payload.personalInformation.lastName,
                userName: payload.userName,
                roles: payload.userRoles,
                role: payload.userRoles != null ? payload.userRoles[0].role : null,
                dodAttache: payload.dodAttacheInformation,
                // : payload.contactInformation.find(e => e.contactType === 'EMAIL').contactValue || null,
                emailAddress: payload.contactInformation == null ? null : getData('EMAIL'),
                // : payload.contactInformation.find(e => e.contactType === 'PHONE_NUMBER').contactValue || null
                phoneNumber: payload.contactInformation == null ? null : getData('PHONE_NUMBER')

            };

        case YAA.FAILURE_YOUR_ACCOUNT_REQUEST:
            return {...state, requests: {...state.requests,
                data: {...state.requests.data, status: 'failure' }
            }};

        case YAA.UPDATE_CONTACT_INFO_REQUEST:
            return {...state, requests: {...state.requests,
                updateContactInfo: {...state.requests.updateContactInfo, status: 'pending' }
            }};

        case YAA.SUCCESS_UPDATE_CONTACT_INFO_REQUEST:
            return {...state, requests: {...state.requests,
                updateContactInfo: {...state.requests.updateContactInfo, status: 'success' }
            }};

        case YAA.FAILURE_UPDATE_CONTACT_INFO_REQUEST:
            return {...state, requests: {...state.requests,
                updateContactInfo: {...state.requests.updateContactInfo, status: 'failure' }
            }};

        case YAA.UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST:
            return {...state, requests: {...state.requests,
                updateSecurityQuestions: {...state.requests.updateSecurityQuestions, status: 'pending' }
            }};

        case YAA.SUCCESS_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST:
            return {...state,
                securityQuestion1: '',
                securityQuestion2: '',
                securityQuestion3: '',
                requests: {...state.requests,
                    updateSecurityQuestions: {...state.requests.updateSecurityQuestions,
                        status: 'success'
                    }
                }
            };

        case YAA.FAILURE_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST:
            return {...state, requests: {...state.requests,
                updateSecurityQuestions: {...state.requests.updateSecurityQuestions, status: 'failure' }
            }};

        case YAA.RESET_EDIT_CONTACT_INFO_FLAGS:
            return {...state,
                loading: false,
                updateContactInfoFailure: false,
                updateContactInfoSuccess: false
            };

        case YAA.RESET_CHANGE_SECURITY_QUESTION_ANSWERS_FLAGS:
            return {...state,
                loading: false,
                updateSecurityQuestionAnswersSuccess: false,
                updateSecurityQuestionAnswersFailure: false
            };

        case YAA.UPDATE_PASSWORD_REQUEST:
            return {...state,
                oldPassword: '',
                newPassword1: '',
                newPassword2: '',
                requests: {...state.requests,
                    updatePassword: {...state.requests.updatePassword,
                        status: 'pending'
                    }
                }
            };

        case YAA.SUCCESS_UPDATE_PASSWORD_REQUEST:
            return {...state, requests: {...state.requests,
                updatePassword: {...state.requests.updatePassword, status: 'success' }
            }};

        case YAA.FAILURE_UPDATE_PASSWORD_REQUEST:
            return {...state, requests: {...state.requests,
                updatePassword: {...state.requests.updatePassword,
                    status: 'failure',
                    code: payload.status
                }
            }};

        case YAA.RESET_YOUR_ACCOUNT_PASSWORD_UPDATE_REQUEST:
            return {...state, requests: {...state.requests,
                updatePassword: new Request()
            }};

        case YAA.RESET_CHANGE_PASSWORD_FLAGS:
            return {...state,
                loading: false,
                updatePasswordSuccess: false,
                updatePasswordFailure: false
            };

        case YAA.GET_EMAIL_PREFERENCES:
            return {...state, requests: {...state.requests,
                emailPreferences: {...state.requests.emailPreferences, status: 'pending' }
            }};

        case YAA.GET_EMAIL_PREFERENCES_SUCCESS:
            return {...state,
                emailPreferences: payload,
                requests: {...state.requests,
                    emailPreferences: {...state.requests.emailPreferences, status: 'success' }
                }
            };

        case YAA.GET_EMAIL_PREFERENCES_FAILURE:
            return {...state, requests: {...state.requests,
                emailPreferences: {...state.requests.emailPreferences, status: 'failure' }
            }};

        case YAA.SAVE_EMAIL_PREFERENCES:
            return {...state, requests: {...state.requests,
                emailPreferencesUpdate: {...state.requests.emailPreferencesUpdate, status: 'pending' }
            }};

        case YAA.SAVE_EMAIL_PREFERENCES_SUCCESS:
            return {...state, requests: {...state.requests,
                emailPreferencesUpdate: {...state.requests.emailPreferencesUpdate, status: 'success' }
            }};

        case YAA.SAVE_EMAIL_PREFERENCES_FAILURE:
            return {...state, requests: {...state.requests,
                emailPreferencesUpdate: {...state.requests.emailPreferencesUpdate, status: 'failure' }
            }};

        case YAA.CHANGE_YOUR_ACCOUNT_VIEW:
            return setStateValues(action.newState || null, {...state, view: action.payload });

        case YAA.UPDATE_DATA_ENTRY:
            return {...state, [payload.name]: payload.value };

        case YAA.UPDATE_EMAIL_CHECKBOX:
            const { name, checked } = payload;
            return {...state, emailPreferences: state.emailPreferences.map(p => {
                if(p.emailTypeCode === name) return {...p, optout: checked }
                else return p;
            })};

        case YAA.TOGGLE_CAN_UPDATE_CONTACT_INFO:
            return {...state, canUpdateContactInfo: !state.canUpdateContactInfo };

        case YAA.RESET_YOUR_ACCOUNT_DATA_REQUEST:
            return {...state, requests: {...state.requests, data: new Request }};

        case YAA.RESET_YOUR_ACCOUNT_CONTACT_INFO_REQUEST:
            return {...state, requests: {...state.requests, updateContactInfo: new Request }};

        case YAA.RESET_YOUR_ACCOUNT_SECURITY_QUESTIONS_REQUEST:
            return {...state, requests: {...state.requests, updateSecurityQuestions: new Request }};

        case YAA.TOGGLE_YOUR_ACCOUNT_SHOW_VIEW:
            return {...state, showView: payload != null ? payload : !state.showView };

        case YAA.RESET_YOUR_ACCOUNT_VIEW:
            return {...state, view: VIEWS.YOUR_ACCOUNT };

        case YAA.RESET_EMAIL_PREFERENCES_UPDATE:
            return {...state, requests: {...state.requests,
                emailPreferencesUpdate: {...init.requests.emailPreferencesUpdate}
            }};

        default: return {...state};
    }
};
